import { render, staticRenderFns } from "./DataBuildMatchedMLContact.vue?vue&type=template&id=6d6a6bd4&scoped=true"
import script from "./DataBuildMatchedMLContact.vue?vue&type=script&lang=js"
export * from "./DataBuildMatchedMLContact.vue?vue&type=script&lang=js"
import style0 from "./DataBuildMatchedMLContact.vue?vue&type=style&index=0&id=6d6a6bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a6bd4",
  null
  
)

export default component.exports